import React from "react";
import { authPaymentTypes } from "../../parent/data/auth-payment-types";
import { authLogUserClickedAutopayOnCreditCard } from "../../../../utils/requests";

export const SetupAutoPayButton = (props) => {
  const onSetupAutoPayClick = () => {
    window.dispatchEvent(new CustomEvent("closeAllPopupMenusAndAuthModals"));

    if (props.IsCreditOrExternalAccount) {
      // Log event with backend and trigger unique modal message if the user
      // clicks set up autopay button on a credit card
      authLogUserClickedAutopayOnCreditCard(props.AccountHash);
      props.selectPaymentType(authPaymentTypes.invalid.RecurringCreditCard, true);
    } else if (!props.RecurringPaymentIsAllowed || !props.NextDueDate) {
      // If recurring payments are not allowed, or if there is no next due date,
      // set this unique payment type to display the proper message in the modal
      props.selectPaymentType(authPaymentTypes.invalid.IneligibleRecurring, true);
    } else if (props.AmountPastDue && props.ScheduledACHPaysPastDue === false) {
      // If this loan is past due, pass in the unique OverdueRecurring type
      // so the modal knows to display the proper warning content
      props.selectPaymentType(authPaymentTypes.invalid.OverdueRecurring, true);
    } else {
      props.selectPaymentType(authPaymentTypes.valid.Recurring, true);
    }
  };

  if (!props.show) {
    return null;
  }

  return (
    <button
      onClick={onSetupAutoPayClick}
      className="px-0 w-100 autopay-button-display autopay-button-new"
    >
      Set Up Autopay
    </button>
  );
};

export const EditAutoPayButton = (props) => {
  const onEditAutoPayClick = () => {
    window.dispatchEvent(new CustomEvent("closeAllPopupMenusAndAuthModals"));

    if (!props.RecurringPaymentIsAllowed) {
      props.selectPaymentType(authPaymentTypes.invalid.IneligibleRecurring, true);
    } else {
      props.selectPaymentType(authPaymentTypes.valid.Recurring, true);
    }
  };

  if (!props.show) {
    return null;
  }

  return (
    <button
      onClick={onEditAutoPayClick}
      className="px-0 w-100 autopay-button-display autopay-button-edit"
    >
      Edit AutoPay
    </button>
  );
};

export const MakePaymentButton = (props) => {
  const onMakePaymentClick = () => {
    if (props.PayoffPending) {
      props.selectPaymentType(authPaymentTypes.invalid.PayoffPending, false);
    } else if (!props.CurrentBalance && !props.AmountDue) {
      // Block advancement for one time payments when the current balance is zero
      props.selectPaymentType(authPaymentTypes.invalid.ZeroBalance, false);
    } else if (props.IsCreditOrExternalAccount) {
      // Skip the modal since internal account is only option for credit cards
      window.scrollTo(0, 0);
      props.setPaymentInfo((state) => {
        return {
          ...state,
          method: "LakeTrustAccount",
          loanId: props.AccountHash,
          type: authPaymentTypes.valid.Standard,
          isOpenEnded: props.IsOpenEndedLoan,
        };
      });
    } else {
      props.selectPaymentType(authPaymentTypes.valid.Standard, props.AchIsAllowed);
    }
  };

  if (!props.show) {
    return null;
  }

  return (
    <button
      className="px-0 w-100 standard-button-display"
      onClick={onMakePaymentClick}
      data-e2e-id={"makePayment-" + props.lastFour}
    >
      Make a Payment
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/card-payment-buttons.component.js